import { useAtomValue } from "jotai";
import { useRequiredFieldsExistInURL } from "src/pages/ComparativeAnalysisPage/ComparativeAnalysisPage.hooks";
import { comparePitsFormSubmittedAtom } from "src/pages/ComparativeAnalysisPage/components/ComparativeAnalysisForm/ComparativeAnalysisForm.atoms";
import ComparativeAnalysisFormDropdown from "src/pages/ComparativeAnalysisPage/components/ComparativeAnalysisForm/components/ComparativeAnalysisFormDropdown/ComparativeAnalysisFormDropdown";
import { useComparativeAnalysisFormDropdownOpen } from "src/pages/ComparativeAnalysisPage/components/ComparativeAnalysisForm/components/ComparativeAnalysisFormDropdown/ComparativeAnalysisFormDropdown.atoms";

const TopbarComparativeAnalysisForm = () => {
  const [comparativeAnalysisFormDropdownIsOpen] =
    useComparativeAnalysisFormDropdownOpen();

  const isFormSubmitted = useAtomValue(comparePitsFormSubmittedAtom);
  const requiredFieldsExistInURL = useRequiredFieldsExistInURL();
  const shouldRender =
    (requiredFieldsExistInURL && isFormSubmitted) ||
    comparativeAnalysisFormDropdownIsOpen;

  return shouldRender ? <ComparativeAnalysisFormDropdown /> : null;
};

export default TopbarComparativeAnalysisForm;
